import { EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-[#05091B] text-white/70 border-t border-white/5">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10 py-14">
                <div className="grid md:grid-cols-12 gap-10">
                    {/* Brand */}
                    <div className="md:col-span-5">
                        <div className="mb-5">
                            <img
                                src="/lumos-logo-white.png"
                                alt="LUMOS Audit Énergétique"
                                className="h-20 lg:h-24 w-auto object-contain"
                            />
                        </div>
                        <p className="text-sm max-w-md leading-relaxed">
                            Bureau d&apos;étude thermique certifié RGE. Audit énergétique, DPE collectif, DTG et PPPT pour maisons, copropriétés et immeubles depuis 2022.
                        </p>
                    </div>

                    {/* Quick links */}
                    <div className="md:col-span-3">
                        <h4 className="text-white font-display font-bold mb-4 text-sm tracking-widest uppercase">Navigation</h4>
                        <ul className="space-y-2.5 text-sm">
                            <li><a href="#prestations" className="hover:text-lumos-blue transition-colors">Prestations</a></li>
                            <li><a href="#tarifs" className="hover:text-lumos-blue transition-colors">Tarifs</a></li>
                            <li><a href="#process" className="hover:text-lumos-blue transition-colors">Démarche</a></li>
                            <li><a href="#zones" className="hover:text-lumos-blue transition-colors">Zones d&apos;intervention</a></li>
                            <li><a href="#contact" className="hover:text-lumos-blue transition-colors">Contact</a></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="md:col-span-4">
                        <h4 className="text-white font-display font-bold mb-4 text-sm tracking-widest uppercase">Contact</h4>
                        <ul className="space-y-3 text-sm">
                            <li><a href="mailto:contact@lumosaudit.com" className="flex items-center gap-2.5 hover:text-lumos-blue transition-colors">
                                <EnvelopeSimple size={16} weight="bold" /> contact@lumosaudit.com
                            </a></li>
                            <li><a href="tel:+33186958700" className="flex items-center gap-2.5 hover:text-lumos-blue transition-colors">
                                <Phone size={16} weight="bold" /> 01.86.95.87.00
                            </a></li>
                            <li className="flex items-start gap-2.5">
                                <MapPin size={16} weight="bold" className="mt-0.5 flex-shrink-0" />
                                <span>10 rue du Colisée<br />75008 Paris</span>
                            </li>
                        </ul>
                        <div className="mt-5 flex flex-wrap gap-2">
                            <span className="px-2.5 py-1 rounded-full bg-lumos-green/15 border border-lumos-green/30 text-lumos-green text-[11px] font-bold tracking-wider uppercase">Île-de-France</span>
                            <span className="px-2.5 py-1 rounded-full bg-lumos-blue/15 border border-lumos-blue/30 text-lumos-blue text-[11px] font-bold tracking-wider uppercase">Oise (60)</span>
                            <span className="px-2.5 py-1 rounded-full bg-lumos-amber/15 border border-lumos-amber/30 text-lumos-amber text-[11px] font-bold tracking-wider uppercase">Aisne (02)</span>
                        </div>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
                    <div>© {new Date().getFullYear()} LUMOS · Bureau d&apos;étude thermique certifié RGE · Tous droits réservés.</div>
                    <div className="flex flex-wrap gap-5">
                        <a href="#mentions" className="hover:text-white transition-colors">Mentions légales</a>
                        <a href="#confidentialite" className="hover:text-white transition-colors">Politique de confidentialité</a>
                        <a href="/sitemap.xml" className="hover:text-white transition-colors">Plan du site</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
